import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { CALL_STORE_FOR_PRICE_FIRST_TEXT } from 'constant'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Quantity from 'components/common/Quantity/Quantity'
import Media from 'components/common/Media'
import { A } from 'components/common/Link/Link'
import PhoneLink from 'components/common/PhoneLink'
import { formatPrice } from 'helpers/utils'

const QuantityPrice = ({
  count,
  priceTitle,
  priceOld,
  priceSale,
  priceSet,
  quantityInputId,
  defaultValue,
  hidePriceOfSet,
  handleQuantityChange,
  minValue = 0,
  storePhoneNumber,
  formattedStorePhoneNumber,
  showStoreLocatorModal,
  dataAttributes,
  isShowPrice,
  isShowCallStoreForPrice,
  isShowSelectStore,
  hasMapPrice,
  seePriceIncartMessage,
  mapShowPhoneNumber,
  model = {}
}) =>
  <Fragment>
    { priceTitle &&
      <PriceTitle>{ priceTitle }</PriceTitle>
    }

    { (priceOld && !hasMapPrice) ?
      <FieldWrapper data-at-quantity-price-wrapper>
        <Price data-at-quantity-price block { ...dataAttributes } >{ formatPrice(priceSale || priceOld) }</Price>
        { (priceSale > 0) &&
          <Price small old>{ formatPrice(priceOld) }</Price>
        }
        <Price small>/each</Price>
        {
          !hidePriceOfSet &&
          <Price data-at-quantity-price-setof small set>
            <Price small bold>${ (count * (priceSale || priceOld)).toFixed(2) }</Price>set of { count }
          </Price>
        }
      </FieldWrapper> :
      <FieldWrapper data-at-quantity-price-wrapper>
        <PriceLink data-at-serp-tire-seepriceincart>
          {
            isShowCallStoreForPrice &&
              <Fragment>
                <Phone>{ CALL_STORE_FOR_PRICE_FIRST_TEXT }</Phone>
                <Media.Desktop><Phone>{ formattedStorePhoneNumber }</Phone></Media.Desktop>
                <Media.Mobile><StyledPhoneLink number={ storePhoneNumber } /></Media.Mobile>
              </Fragment>
          }
          {
            isShowPrice && !hasMapPrice &&
              <Fragment>
                <Price block>{ formatPrice(priceSale || priceOld) }</Price>
                <Price small>/each</Price>
              </Fragment>
          }
          {
            isShowSelectStore &&
              <SelectStoreLink prevent handler={ showStoreLocatorModal }>Select store for Price</SelectStoreLink>
          }
          {
            hasMapPrice && !isShowSelectStore && !isShowCallStoreForPrice && <Fragment>
              <Phone block>
                { seePriceIncartMessage }
              </Phone>
              { mapShowPhoneNumber &&
                <Fragment>
                  <Media.Desktop><Phone>{ formattedStorePhoneNumber }</Phone></Media.Desktop>
                  <Media.Mobile><StyledPhoneLink number={ storePhoneNumber } /></Media.Mobile>
                </Fragment>
              }
            </Fragment>
          }
        </PriceLink>
      </FieldWrapper>
    }

    <FieldWrapper right>
      <fieldset>
        <QuantityText>Qty</QuantityText>
        <Media.Desktop>
          <TireQuantity
            id={ quantityInputId }
            minValue={ minValue }
            defaultValue={ defaultValue }
            onChange={ handleQuantityChange } />
        </Media.Desktop>
        <Media.Mobile>
          <TireQuantity
            id={ quantityInputId }
            scalable
            small
            minValue={ minValue }
            defaultValue={ defaultValue }
            onChange={ handleQuantityChange } />
        </Media.Mobile>
      </fieldset>
    </FieldWrapper>

  </Fragment>

QuantityPrice.propTypes = {
  count: PropTypes.number,
  dataAttributes: PropTypes.shape(),
  defaultValue: PropTypes.number,
  formattedStorePhoneNumber: PropTypes.string,
  handleQuantityChange: PropTypes.func,
  hasMapPrice: PropTypes.bool,
  hidePriceOfSet: PropTypes.bool,
  isShowCallStoreForPrice: PropTypes.bool,
  isShowPrice: PropTypes.bool,
  isShowSelectStore: PropTypes.bool,
  mapShowPhoneNumber: PropTypes.bool,
  minValue: PropTypes.number,
  model: PropTypes.shape(),
  priceOld: PropTypes.number,
  priceSale: PropTypes.number,
  priceSet: PropTypes.number,
  priceTitle: PropTypes.string,
  quantityInputId: PropTypes.string,
  seePriceIncartMessage: PropTypes.string,
  showStoreLocatorModal: PropTypes.func,
  storePhoneNumber: PropTypes.string
}

export default QuantityPrice

const Price = styled.span`
  margin-right: 6px;
  line-height: 33px;
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamBold(24)}
  ${props => props.small && css`
    margin-right: 5px;
    color: ${Theme.colors.medium_grey};
    line-height: 19px;
    ${Mixin.font.GothamBook(14)}
  `}
  ${props => props.old && css`
    line-height: 18px;
    text-decoration: line-through;
  `}
  ${props => props.block && css`
    ${Media.mobile`
      display: block;
    `}
  `}
  ${props => props.set && css`
    display: block;
    color: ${Theme.colors.dark_grey};
  `}
  ${props => props.bold && css`
    font-weight: 700;
  `}
`

const FieldWrapper = styled.div`
  ${Media.mobile`
    display: inline-block;
    vertical-align: top;
    text-align: left;
  `}
  ${Mixin.responsive('margin-bottom', '20px', '17px')}
  ${props => props.right && css`
    text-align: right;
    ${Media.mobile`
      display: inline-flex;
      align-items: left;
    `}
  `}
`

const TireQuantity = styled(Quantity)`
  width: 155px;
  background-color: ${Theme.colors.white};
`

const QuantityText = styled.legend`
  float: left;
  margin: 11px 8px 0 0;
  line-height: 19px;
  color: ${Theme.colors.dark_grey};
  ${Mixin.font.GothamBook(14)}
  ${Media.mobile`
    margin-right: 10px;
  `}
`

const PriceTitle = styled.div`
  ${Mixin.font.GothamBold()}
  line-height: 19px;
  color: ${Theme.colors.sub_grey};
  text-transform: uppercase;
  ${Media.mobile`
    margin: -3px 0 -5px;
    font-size: 10px;
    line-height: 14px;
    color: ${Theme.colors.black};
  `}
`

const PriceLink = styled.div`
  color: ${Theme.colors.sub_grey};
  line-height: 33px;
  ${Mixin.font.GothamBold(20)}
  ${Media.mobile`
    font-size: 16px;
    line-height: 20px;
  `}
`

const Phone = styled.div`
  ${Mixin.font.GothamBold(20, 600, 22)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(16, 600, 20)}
  `}
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  ${Mixin.font.GothamBold(16, 600, 20)}
`

const SelectStoreLink = styled(A)`
  ${Mixin.font.GothamBold()}
  ${Mixin.responsive('font-size', '16px', '14px')}
`
